import { InputSwitch } from "primereact/inputswitch";
import { classNames } from "primereact/utils";
import { AppDialog } from "../../../../common/components/AppDialog/AppDialog";
import {
  IfFalse,
  IfTrue,
  RenderWhen,
} from "../../../../common/infrastructure/components/RenderWhen";
import styles from "./AutoPayDialog.module.scss";

interface IAutoPayDialogProps {
  visible: boolean;
  onHide: () => void;
  switchValue: boolean;
  onSwitchChange: (value: boolean) => void;
  onContinue: () => void;
  isProcessing: boolean;
  hasCard: boolean;
  cardBrand?: string | null;
  cardLast4?: string | null;
}

export const AutoPayDialog = ({
  visible,
  onHide,
  switchValue,
  onSwitchChange,
  onContinue,
  isProcessing,
  hasCard,
  cardBrand,
  cardLast4,
}: IAutoPayDialogProps) => (
  <AppDialog
    header="Автоматично плащане"
    visible={visible}
    onHide={onHide}
    className={styles.root}
    closable={!isProcessing}
  >
    <div className={styles.content}>
      <div className={styles.switch_row}>
        <label htmlFor="autoPayDialogSwitch" className={styles.switch_row_label}>
          <RenderWhen condition={hasCard}>
            <IfTrue>
              Таксувай автоматично бъдещите фактури със запазената карта
              {cardLast4 ? ` (${cardBrand ?? "карта"} •••• ${cardLast4})` : ""}
            </IfTrue>
            <IfFalse>
              Запази картата и плащай бъдещите фактури автоматично
            </IfFalse>
          </RenderWhen>
        </label>
        <InputSwitch
          inputId="autoPayDialogSwitch"
          checked={switchValue}
          onChange={(e) => onSwitchChange(!!e.value)}
          disabled={isProcessing}
        />
      </div>

      <RenderWhen condition={switchValue}>
        <IfTrue>
          <p className={styles.consent}>
            С продължаването се съгласявате Planny автоматично да таксува картата
            Ви при издаване на всяка следваща фактура. Сумата може да варира
            според абонамента и използваните услуги. Можете да изключите
            автоматичното плащане по всяко време от страницата с фактурите.
            Картовите данни се съхраняват сигурно в Stripe и не достигат до нас.
          </p>
        </IfTrue>
        <IfFalse>
          <p className={styles.consent}>
            Ще платите еднократно само тази фактура, без да се запазва карта.
          </p>
        </IfFalse>
      </RenderWhen>

      <button
        className={classNames(styles.continue, {
          [styles.continue_loading]: isProcessing,
        })}
        onClick={onContinue}
        disabled={isProcessing}
      >
        Продължи към плащането
        {isProcessing && <span className={styles.continue_spinner} />}
      </button>
    </div>
  </AppDialog>
);
